import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import ExamAI from './ExamAI';
import PrintExams from '../PrintExams';

const ExamDetailsLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'ExamDetails' */ './components/ExamDetails')
);

export default (store) => {
	return [
		{
			path: 'exams/:examId',
			element: <AsyncLoading component={<ExamDetailsLazy />} />,
		},
		ExamAI(store),
		PrintExams(store),
	];
};
